import { useCallback, useState } from 'react';

/**
 * A column width people can drag, remembered per browser under `key`.
 * Clamped to [min, max]; storage failures (private mode) just fall back to
 * the default, so the column still works.
 */
export function useResizableWidth(key: string, initial: number, min: number, max: number) {
  const clamp = useCallback((w: number) => Math.round(Math.min(max, Math.max(min, w))), [min, max]);
  const [width, setState] = useState<number>(() => {
    try {
      const saved = Number(localStorage.getItem(`grc-width:${key}`));
      return saved ? clamp(saved) : initial;
    } catch {
      return initial;
    }
  });
  const setWidth = useCallback((w: number) => {
    const next = clamp(w);
    setState(next);
    try { localStorage.setItem(`grc-width:${key}`, String(next)); } catch { /* private mode */ }
  }, [clamp, key]);
  const reset = useCallback(() => setWidth(initial), [setWidth, initial]);
  return { width, setWidth, reset, min, max };
}
